import './BankConnectionModal.scss';
import { Button, Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import Moment from 'moment';
import BankService from '../../../Services/BankService';
import LoadingBar from '../../../Components/LoadingBar/LoadingBar';

const gT = (t, key) => t(`modal.bank-connection${key}`);
const gsT = (t, key) => t(`shared${key}`);

/* eslint-disable react/prop-types */
export default function BankConnectionModal({ handleClose, client, t }) {
  const [session, setSession] = useState(null);

  useEffect(() => {
    const getSession = async () => {
      await BankService.getClientBankSession(client.id)
        .then((response) => setSession(response.data))
        .catch(() => {});
    };

    if (Object.keys(client).length !== 0) {
      getSession();
    }
  }, [client]);

  return (
    <Modal
      show
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      className="border-0 bank-modal-wrapper"
    >
      <Modal.Header>
        <Modal.Title>
          {`${gT(t, '.modal-title-prefix')} ${client.name}`}
        </Modal.Title>
        <Button className="btn-close" bsPrefix="button" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="border-0">
        {(client.bankConnectionActive || client.hadBankConnection) && (
          <div className="bank-connected-view">
            {session === null ? (
              <LoadingBar
                active
                status={gsT(t, '.actions.fetching')}
                relative
              />
            ) : (
              <div
                className={`bank-session-content ${
                  session.status === 'AUTHORIZED'
                    ? 'session-ok'
                    : 'session-error'
                }`}
              >
                <div className="bank-session-status">
                  <p>{session.status}</p>
                </div>
                <div className="bank-session-details">
                  <p>
                    <b>
                      {gsT(t, '.labels.bank')}
                      &colon;&nbsp;
                    </b>
                    {session.bankName}
                  </p>
                  <p>
                    <b>
                      {gT(t, '.bank-session-details.country-code')}
                      &colon;&nbsp;
                    </b>
                    {session.bankCountry}
                  </p>
                  <p>
                    <b>
                      {gT(t, '.bank-session-details.connection-valid-to')}
                      &colon;&nbsp;
                    </b>
                    {Moment.utc(session.validUntil)
                      .local()
                      .format('YYYY-MM-DD HH:mm')}
                  </p>
                  {session.status !== 'AUTHORIZED' &&
                    new Date(session.validUntil) >
                      new Date(Moment.utc().local()) && (
                      <p className="session-error-text">
                        {gT(t, '.session-error-text')}
                      </p>
                    )}
                </div>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
